export const requerimento = {
  AuthTitleFormRequerimento: "AuthTitleFormRequerimento",
  AuthLabelPolicyPrivacy: "AuthLabelPolicyPrivacy",
  AuthLabelProtectionData: "AuthLabelProtectionData",
  AuthLabelProtectionDataLink: "AuthLabelProtectionDataLink",
}
